// Display labels for participant field names. Used in Phase B's auto-merge
// banner ("We added: phone, address.") and Phase C's conflict-resolution
// modal. Maps storage column name → user-facing label.
//
// Sensitive fields (Phase 5b SENSITIVE_FIELDS):
//   phone, email, address, birth_date, birth_year, approximate_age, bahai_status
// Non-sensitive fields tracked by try_add_or_merge_by_email:
//   first_name, last_name, locality, sex, age_category, private_notes

export const FIELD_LABELS = {
  // Identity
  first_name:      "First name",
  last_name:       "Last name",
  // Contact (sensitive)
  phone:           "Phone",
  email:           "Email",
  address:         "Address",
  // Demographics (sensitive)
  birth_date:      "Birth date",
  birth_year:      "Birth year",
  approximate_age: "Age",
  bahai_status:    "Bahá'í status",
  // Other non-sensitive
  locality:        "Locality",
  sex:             "Sex",
  age_category:    "Age category",
  private_notes:   "Notes",
}

export const fieldLabel = (name) => FIELD_LABELS[name] ?? name
